import { LogPaymentMethodUpdateState } from './logPaymentMethodUpdate.types'

const initialState: LogPaymentMethodUpdateState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
